import {Init} from 'core/Init';

import {APP_EVT} from 'core/config/constants';

class QuoteRequest {

    private static modal: string;

    /**
     *
     * @param setDesign
     */
    constructor(setDesign) {

        QuoteRequest.modal = '#modal-quote-request';

        Init.emitter.on(APP_EVT.SHOW_QUOTE_REQUEST_MODAL, this.showQuoteRequestModal);

        $('#btn-qr-submit').on('click', function (this) {

            Init.emitter.emit(APP_EVT.SUBMIT_QUOTE_REQUEST);

        });


        $(QuoteRequest.modal).on('click', '#btn-qr-close', function (this) {

            $(QuoteRequest.modal).modal('toggle');

        });

        Init.emitter.on(APP_EVT.SUBMIT_QUOTE_REQUEST, this.submitQuoteRequest);

    }


    /**
     *
     */
    showQuoteRequestModal = (): void => {

        // check first to see if there is a saved design to quote
        if (Init.design_id == '' || Init.design_timestamp == undefined) {

            let modal: string = '#modal-blank';
            $(modal + ' #msg').text('please save the design before requesting a quote');
            $(modal).modal('show');
            return;

        }

        $(QuoteRequest.modal + ' .cat-req').css('display', 'flex');

        $(QuoteRequest.modal).modal('toggle');

        $(QuoteRequest.modal + ' #btn-qr-submit').prop('disabled', false);

        //let json_params : any = localStorage.getItem('quote_params');
        let json_params : any = Init.getStorage('quote_params');
        let params : any = JSON.parse(json_params);

        $.each(params, function(i, val) {
            $('#qr_' + String(i)).val(val);
        });

        $(QuoteRequest.modal + ' .msg').html('');

    };


    /**
     * see if we have a design already saved under this name
     *
     */
    submitQuoteRequest = (): void => {

        $(QuoteRequest.modal + ' .msg').html('');

        $(QuoteRequest.modal + ' .is-invalid').removeClass('is-invalid');

        if (Init.design_id == '' || Init.design_id == undefined) {

            $(QuoteRequest.modal + '  .msg')
                .append('<div class="alert alert-warning">Please save a design before requesting a quote.</div>');
            return;

        }

        let qr_fields: string[] = [
            'email_address',
            'phone',
            'comments',
            'age_range',
            'first_name',
            'last_name',
            'company_name',
            'address',
            'city',
            'state',
            'zip',
            'country',
            'commercial_cat'
        ];

        let data: any =  this.buildPost(qr_fields);

        //localStorage.setItem('quote_params', JSON.stringify(data));
        Init.setStorage('quote_params', JSON.stringify(data));

        data.cat_request = false;
        data.design_id = Init.design_id;
        data.series_id = Init.series_id;
        data.design_name = Init.design_name;
        data.app_version = Init.app_file_name;
        data.auth_user_id = Init.user_auth_id;
        data.cat_request = true;

        let _that: QuoteRequest = this;

        $.ajax({
            type: 'POST',
            url: '/data/submitQuoteRequest',
            dataType: 'json',
            data: data
        })
            .done(function (data) {
                if (data.original && data.original.errors) {
                    //console.log(data.original.errors);
                    _that.showErrors(data.original.errors);
                } else {
                    _that.showSuccess();
                }
            })
            .fail(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
            });

    };


    buildPost = (values): any => {

        let data :  any = {};

        $.each(values, function (i, val) {

            data[val] = $(QuoteRequest.modal + ' #qr_' + val).val();

        });

        return data;

    };


    showSuccess = (): void => {

        //localStorage.setItem('quote', 'requested');
        Init.setStorage('quote', 'requested');

        $(QuoteRequest.modal + ' .msg')
            .append('<div class="alert alert-success">your quote request was successful. &nbsp; <button type="button" class="btn btn-wide" id="btn-qr-close">close</button></div>');

        $(QuoteRequest.modal + ' #btn-qr-submit').prop('disabled', true);

        Init.emitter.emit(APP_EVT.SET_GTAG, 'quote_request');

    };

    showErrors = (errors): void => {

        $.each(errors, function (field_name: string, error: string[]) {

            $(QuoteRequest.modal + ' #qr_' + field_name).addClass('is-invalid');
            $(QuoteRequest.modal + ' #qr_' + field_name + '_feedback').text(error[0]);
        });

        $(QuoteRequest.modal + ' .msg')
            .append('<div class="alert alert-danger">Please fill in all required fields.</div>');

    };


    /** **************************************************************
     *                                   GETTERS - SETTERS
     */

}

export {QuoteRequest}

